// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header_1za7K","headerContainer":"App_headerContainer_3Wtg6","logo":"App_logo_5R6HP","nav":"App_nav_3WK5t","navLink":"App_navLink_bnaHj","footer":"App_footer_1bfO4"};